<template>
  <div class="text-capitalize">
    <add-transfer :is-active.sync="isAdding" @changed="transferCompleted" />
    <download-invoices-modal :is-active.sync="isDowloading" @downloaded="invoicesDownloaded" />
    <tab-filters :tabs="tabs" @selected="selectedTab = $event.value" />
    <data-table
      :headers="headers"
      :url="url"
      title="Bulk Transfers"
      searchable
      ref="table"
      :fields="fields"
      :csv="true"
      csvFileName="transfers.csv"
      :csvFields="csvFields"
      :archive="true"
      :dateSort="true"
      @date-range-updated="(url) => (this.url = url)"
      @update-archived="(status) => (this.showArchived = status)"
      @click:row="showTransferDetails"
    >
      <template slot="action.icons">
        <!-- <v-btn color="primary" @click="isAdding = true" class="mr-3">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Make A Transfer
        </v-btn> -->
        <v-btn color="primary" @click="isDowloading = true">
          <v-icon color="light-blue lighten-4 mr-2">
            mdi-email-send
          </v-icon>
          Dowload Invoices
        </v-btn>
      </template>
      <template slot="item.type" slot-scope="{ item }">{{ item.type | title }}</template>
      <template slot="item.provider" slot-scope="{ item }">{{ item.provider | title }}</template>
      <template slot="item.amount" slot-scope="{ item }">€{{ item.amount_without_fee }}</template>
      <template slot="item.payment_delivery" slot-scope="{ item }">{{
        item.payment_delivery ? "Yes" : "No"
      }}</template>
    </data-table>
  </div>
</template>
<script>
import TabFilters from "@/components/TabFilters";
import AddTransfer from "./form";
export default {
  components: { TabFilters, AddTransfer },
  data() {
    return {
      isDowloading: false,
      showArchived: false,
      selectedTab: "",
      isAdding: false,
      url: "/api/v1/transactions/bulkTransfers",
      headers: {
        created_at: "Date (created at)",
        "source_user.full_name": "Sender full name",
        "source_user.country": "Sender country",
        "payment.amount": " Amount without fee (Euro)",
        type: "Payment Type",
        status: "Transfer Status",
      },
      /*  Days before transfer */
      fields: {
        status: { type: "title" },
      },
      tabs: [
        { name: "All", value: "", icon: "mdi-view-list" },
        { name: "Card", value: "card", icon: "mdi-credit-card" },
        {
          name: "Bank Transfer",
          value: "bank_transfer",
          icon: "mdi-bank-transfer-in",
        },
      ],
      csvFields: [
        {
          label: "Sender ID",
          value: "source_user.id",
          default: "",
        },
        {
          label: "Sender Full name",
          value: "source_user.full_name",
          default: "",
        },
        {
          label: "Sender Phone Number",
          value: "source_user.full_phone_number",
          default: "",
        },
        {
          label: "Sender Is Owner",
          value: "source_user.is_individual",
          default: "",
        },

        {
          label: "Payment Type",
          value: "type",
          default: "",
        },
        {
          label: "Amount(Euros)",
          value: function (row) {
            let name = "";
            name = `${row.amount}`;

            return name;
          },
          default: "",
        },
        {
          label: "Fees",
          // eslint-disable-next-line no-unused-vars
          value: "applied_fees.value",
        },

        {
          label: "Started at",
          value: "started_at",
          default: "",
        },
        {
          label: "Done At",
          value: "done_at",
          default: "",
        },
        {
          label: "Status",
          value: "status",
          default: "",
        },
      ],
    };
  },
  methods: {
    transferCompleted() {},
    showTransferDetails({ id }) {
      return this.$router.push({ name: "bulktransfers.show", params: { id } });
    },
    invoicesDownloaded({ message }) {
      this.isDowloading = false;
      Notify.success(message);
    },
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
    selectedTab: function (val) {
      // extract the first section of the url to avoid concatnating on existing type
      const url_section = this.url.split("?")[0];
      this.url = `${url_section}?${this.$refs.table.addParams(this.url, [
        { name: "type", value: val },
      ])}`;
    },
    showArchived: function (val) {
      const params = this.$refs.table.addParams(this.url, []);
      if (val) {
        this.url = `/api/v1/transactions/bulkTransfers?${params}`;
      } else {
        this.url = `/api/v1/transactions/bulkTransfers?${params}`;
      }
    },
  },
};
</script>
